import { COLOR } from 'app-v2/design-tokens'
import { ButtonMedium, media } from 'app/assets/styles'
import { H4, SmallText, Text } from 'app/common/typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'

type Props = {
    background?: string,
    btnColor: string,
    textColor?: string,
    title?: string,
    baseline?: string,
    upButton: string,
    bottomButton?: string,
    onClickFirstButton: () => void,
    onClickSecondButton?: () => void,
    className?: string
}

export const SwitchPush = ({
    background,
    btnColor,
    textColor = COLOR.PRIMARY,
    title,
    baseline,
    upButton,
    bottomButton,
    onClickFirstButton,
    onClickSecondButton,
    className
}: Props) => {
    return (
        <PushContainer background={background} className={className}>
            {!!title && (
                <StyledH4 color={textColor} className={className}>
                    {title}
                </StyledH4>
            )}
            {!!baseline && (
                <StyledText color={textColor} className={className}>
                    {baseline}
                </StyledText>
            )}
            <StyledButtonMedium
                onClick={onClickFirstButton}
                background={btnColor}
                border={btnColor}
                className={className}
                color="white"
                bottomButton={bottomButton}>
                {upButton}
            </StyledButtonMedium>
            {!!bottomButton && (
                <div>
                    <OrContainer>
                        <Line />
                        <FormattedMessage id="or">
                            {(text: string) => (
                                <OrText center color={colors.lightGrey}>
                                    {text.toString().toUpperCase()}
                                </OrText>
                            )}
                        </FormattedMessage>
                        <Line />
                    </OrContainer>
                    <StyledButtonMedium
                        onClick={onClickSecondButton}
                        border={btnColor}
                        className={className}
                        color={btnColor}>
                        {bottomButton}
                    </StyledButtonMedium>
                </div>
            )}
        </PushContainer>
    )
}

const PushContainer = styled.div`
    ${props => props.background && `background-color: ${props.background}`};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    padding: 10px;
    width: 90%;
    border-radius: 8px;
    ${media.medium`
            width: calc(100% / 2);
        `};
`

const StyledButtonMedium = styled(ButtonMedium)`
    background-color: ${props =>
        props.background ? props.background : `white`};
    border: solid 1px ${props => !!props.border && props.border};
    margin: ${props => (props.bottomButton ? `10px` : `10px 0 20px`)};
    align-items: center;
    min-width: 150px;
`

const StyledH4 = styled(H4)`
    margin-top: 20px;
    text-align: center;
`

const StyledText = styled(Text)`
    text-align: center;
    margin: 20px 0 10px;
`

const OrContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const Line = styled.div`
    height: 1px;
    background: ${colors.lightGrey};
    margin: 10px 0;
    width: 40%;
`

const OrText = styled(SmallText)`
    margin: 0 10px;
`
